import { useNavigate } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { useBrand } from "@/contexts/BrandContext";
import { Button } from "@/components/ui/button";

type Props = { onScrollDown: () => void };

export default function HeroSection({ onScrollDown }: Props) {
  const { language } = useLanguage();
  const { localizedName, localizedTagline, brand } = useBrand();
  const navigate = useNavigate();

  return (
    <section className="relative min-h-[90vh] flex flex-col items-center justify-center text-center overflow-hidden">
      {/* Background video */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        >
          {brand.heroVideoUrl && (
            <source
              src={brand.heroVideoUrl}
              type="video/mp4"
            />
          )}
        </video>
      </div>

      {/* Dark warm overlay */}
      <div className="absolute inset-0 bg-black/70 z-10" />

      <div className="relative z-20 max-w-3xl mx-auto px-4 space-y-8 animate-fade-in">
        <h1 className="font-heading text-6xl md:text-8xl lg:text-9xl font-black text-white leading-[1.05] tracking-tight drop-shadow-lg">
          {localizedName(language)}
        </h1>
        <p className="text-lg md:text-2xl text-white/70 max-w-2xl mx-auto leading-relaxed">
          {localizedTagline(language)}
        </p>

        {/* Stacked CTA buttons */}
        <div className="flex flex-col items-center gap-4 pt-6 max-w-xs mx-auto">
          <Button
            size="lg"
            className="w-full rounded-md px-10 py-7 text-lg font-bold bg-primary text-primary-foreground hover:bg-primary/85 shadow-xl"
            onClick={() => navigate("/menu")}
          >
            {language === "ar" ? "اطلب الآن" : "Order Now"}
          </Button>
          {/* <Button
            size="lg"
            variant="outline"
            className="w-full rounded-md px-10 py-7 text-lg font-bold border-primary/60 text-primary bg-transparent hover:bg-primary/10"
            onClick={() => navigate("/menu")}
          >
            {language === "ar" ? "تصفح القائمة" : "Browse Menu"}
          </Button> */}
        </div>
      </div>

      <button
        onClick={onScrollDown}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 animate-bounce text-white/40 hover:text-white/70 transition-colors"
        aria-label="Scroll down"
      >
        <ChevronDown className="w-8 h-8" />
      </button>
    </section>
  );
}
